var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcChevronLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8047 2.86128C11.0651 3.12163 11.0651 3.54374 10.8047 3.80409L6.60948 7.99935L10.8047 12.1946C11.0651 12.455 11.0651 12.8771 10.8047 13.1374C10.5444 13.3978 10.1223 13.3978 9.86193 13.1374L5.19526 8.47075C4.93491 8.2104 4.93491 7.78829 5.19526 7.52794L9.86193 2.86128C10.1223 2.60093 10.5444 2.60093 10.8047 2.86128Z",
    fill: "#116584"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChevronLeft);
export default __webpack_public_path__ + "static/media/ic-chevron-left.d2ac00348ccbbbfef41b949bd6fce4ea.svg";
export { ForwardRef as ReactComponent };